import {NgModel} from 'model/ngModel';

export const JobRelatedExpertComparator = NgModel.extend({
    _name: 'JobRelatedExpertComparator',
});
